<template>
  <v-data-table
    :headers="headers"
    :items="notifications"
    :items-per-page="10"
    class="transparent"
    height="560px"
    :footer-props="{
      'items-per-page-options': [5, 10, 15, 20, -1],
      'items-per-page-text': 'Registros por página:',
    }"
    :item-class="getRowClass"
  >
    <template #[`item.prioridad`]="{ item }">
      <NotificationPriorityChip :priority="item.prioridad" />
    </template>
    <template #[`item.categoria`]="{ item }">
      <NotificationCategoryChip :category="item.categoria" />
    </template>
    <template #[`item.mensaje`]="{ item }">
      <section class="py-2">
        <h4>{{ item.titulo }}</h4>
        <div>{{ item.mensaje }}</div>
      </section>
    </template>
    <template v-slot:[`item.opciones`]="{ item }">
      <div class="d-flex justify-center" v-if="shouldShowMarkAsReadButton(item)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <IconButton small v-bind="attrs" v-on="on" variant="secondary" icon="mdi-check" @click="markAsRead(item)" />
          </template>
          <span>Marcar como leído</span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import NotificationPriorityChip from './NotificationPriorityChip.vue'
import NotificationCategoryChip from './NotificationCategoryChip.vue'
import IconButton from '../base/IconButton.vue'
import { mapActions, mapGetters } from 'vuex'
import AREAS_PERFILES from '@/modules/notificaciones/domain/AreasPerfiles.js'
import AREAS from '@src/modules/notificaciones/domain/areas'

const AREA_NOTIFICACION_KEYS = {
  [AREAS.RECURSOS_HUMANOS]: 'recursos_humanos',
  [AREAS.ARMERIA]: 'armeria',
  [AREAS.EQUIPAMIENTO]: 'equipamiento',
  [AREAS.IFCSP]: 'ifcsp',
  [AREAS.DESARROLLO_POLICIAL]: 'desarrollo_policial',
  [AREAS.ENLACE_C3]: 'enlace_c3',
  [AREAS.REGISTRO_PERSONAL]: 'registro_personal',
  [AREAS.ENLACE_COMISARIAS]: 'enlace_comisarias',
  [AREAS.EJECUTIVO]: 'ejecutivo',
}

export default {
  components: {
    NotificationPriorityChip,
    NotificationCategoryChip,
    IconButton,
  },

  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      AREAS_PERFILES,
      AREA_NOTIFICACION_KEYS,
    }
  },

  computed: {
    ...mapGetters({ perfil: 'getPerfil' }),

    headers() {
      return [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Prioridad', value: 'prioridad' },
        { text: 'Categoría', value: 'categoria' },
        { text: 'Mensaje', value: 'mensaje', width: '50%' },
        ...(this.perfil !== 'ADMINSITRADOR GENERAL'
          ? [{ text: 'Opciones', value: 'opciones', align: 'center', sortable: false }]
          : []),
      ]
    },
  },

  methods: {
    ...mapActions('notificaciones', ['updateNotification']),
    markAsRead(notification) {
      this.updateNotification({ idNotificacion: notification.id, notificacion: notification })
        .then(() => {
          const area = this.getAreaKeyByPerfil(this.perfil)
          const keyProp = this.AREA_NOTIFICACION_KEYS[area]

          if (keyProp) {
            notification[keyProp] = 2
          }
        })
        .catch((error) => {
          console.error('Error al marcar la notificación como leída:', error)
        })
    },

    GetAreaFromTitle(title) {
      const area = title.slice(0, title.indexOf(':')).trim()
      console.log('Área obtenida:', area)
      return area
    },

    getAreaKeyByPerfil(perfil) {
      if (!perfil) return null
      for (const [areaKey, perfiles] of Object.entries(AREAS_PERFILES)) {
        if (Array.isArray(perfiles) && perfiles.includes(perfil)) {
          return areaKey
        }
      }
      return null
    },

    shouldShowMarkAsReadButton(notification) {
      const area = this.getAreaKeyByPerfil(this.perfil)
      const keyProp = AREA_NOTIFICACION_KEYS[area]

      return notification[keyProp] !== 2
    },

    getRowClass(notification) {
      const area = this.getAreaKeyByPerfil(this.perfil)
      const keyProp = this.AREA_NOTIFICACION_KEYS[area]

      return notification[keyProp] === 2 ? 'row-read' : ''
    },
  },
}
</script>

<style>
.v-data-table .row-read {
  background-color: #beb5b56a !important;
}
</style>
